import React,{useState, useEffect} from 'react';
import './PreviewDialog.css';
import FormPage from './FormPage';
import { useForm, FormProvider } from 'react-hook-form';
import AccessibilityFontSize from './AccessibilityFontSize'
import validateRequired from '../helpers/validateRequired'

const PreviewDialog = ({ open, onClose, schema, header, footer }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [fontSize, setFontSize] = useState(null)
  const [lineHeight, setLineHeight] = useState(null)
  const methods = useForm();
  const { watch, control } = useForm();

  useEffect(() => {
    // ② subscribe to every change; second arg tells you which field changed
    const subscription = watch((allValues, { name /*, type*/ }) => {
      const missing = validateRequired(schema, allValues);
      console.log('🔄 changed:', name, 'missing now:', missing.map(f => f.name));
      console.log(missing)
    });
    return () => subscription.unsubscribe();        // cleanup
  }, [watch, schema]);

  function updateCssText(cssText, newStyles = {}) {
    // Convert cssText into an object
    const styles = cssText
      .split(';')
      .filter(Boolean)
      .reduce((acc, rule) => {
        const [prop, value] = rule.split(':').map(s => s.trim());
        if (prop && value) acc[prop] = value;
        return acc;
      }, {});
  
    // Update specific properties
    if (newStyles['font-size']) styles['font-size'] = newStyles['font-size'];
    if (newStyles['line-height']) styles['line-height'] = newStyles['line-height'];
  
    // Convert back to cssText
    return Object.entries(styles)
      .map(([prop, value]) => `${prop}: ${value}`)
      .join('; ') + ';';
  }

  useEffect(() => {
    const css = {'font-size': `${fontSize}rem !important`, 'line-height': `${lineHeight}rem !important`}
    const smallcss = {'font-size': `${fontSize-0.2}rem !important`, 'line-height': `${lineHeight-0.2}rem !important;`}

    // Only target elements within the preview scrollable area
    const previewArea = document.querySelector('.preview-scrollable-area');
    if (!previewArea) return;

    var elements = previewArea.querySelectorAll('input');
    for (const element of elements)
      if(element.name !== 'accessbtn')
        if(element.type==='date')
          element.style.cssText = updateCssText(element.style.cssText,smallcss)
        else
          element.style.cssText = updateCssText(element.style.cssText,css)


    elements = previewArea.querySelectorAll('label');
    for (const element of elements)
        element.style.cssText = updateCssText(element.style.cssText,css)

    elements = previewArea.querySelectorAll('.label');
    for (const element of elements)
      element.style.cssText = updateCssText(element.style.cssText,css)

    elements = previewArea.querySelectorAll('th');
    for (const element of elements)
      element.style.cssText = updateCssText(element.style.cssText,css)

    elements = previewArea.querySelectorAll('legend');
    for (const element of elements)
      element.style.cssText = updateCssText(element.style.cssText,smallcss)

    elements = previewArea.querySelectorAll('.smallcss');
    for (const element of elements)
      element.style.cssText = updateCssText(element.style.cssText,smallcss)


  },[fontSize, lineHeight])

  const updateFontSize = (e) => {

    setFontSize(e)
    setLineHeight( Math.round(Number((e+0.2)*10))/10)
  }


  // Group fields by page
  const groupedByPage = schema.reduce((acc, field) => {
    const page = field.page || 1;
    if (!acc[page]) acc[page] = [];
    acc[page].push(field);
    return acc;
  }, {});

  const pageCount = Object.keys(groupedByPage).length;

  const handleNext = () => setCurrentPage((p) => Math.min(p + 1, pageCount));
  const handleBack = () => setCurrentPage((p) => Math.max(p - 1, 1));
  

  
  const handleSubmit = (data) => {
    console.log("Submitted data:", data);
    onClose();
  };


  if (!open || !schema || !Array.isArray(schema)) return null;

  return (
    <div className="preview-dialog">
      <div className="preview-overlay" onClick={onClose} />
      <div className="preview-content">
        <button className="close-button" onClick={onClose}>✖</button>

        {/* Header - rendered above scrollable area */}
        {header && header.trim() !== '' && (
          <div className="preview-form-header-content" dangerouslySetInnerHTML={{ __html: header }} />
        )}

        <div className="preview-scrollable-area">
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(handleSubmit)}>
              <FormPage fields={groupedByPage[currentPage] || []} />
              <div className="form-navigation">
                {currentPage > 1 && (
                  <button type="button" className="form-nav-button back" onClick={handleBack}>Back</button>
                )}
                {currentPage < pageCount && (
                  <button type="button" className="form-nav-button next" onClick={handleNext}>Next</button>
                )}
                {currentPage === pageCount && (
                  <button type="button" className="form-nav-button submit" onClick={() => console.log('would ubmit normally')} >Submit</button>
                )}
              </div>
            </form>
          </FormProvider>
        </div>

        {/* Footer - rendered below scrollable area */}
        {footer && footer.trim() !== '' && (
          <div className="preview-form-footer-content" dangerouslySetInnerHTML={{ __html: footer }} />
        )}

        <AccessibilityFontSize defaultsize={1} onChange={updateFontSize} />
      </div>
    </div>
  );
};

export default PreviewDialog;
